module.exports = __webpack_public_path__ + "img/Hot-cheezken-Max-Quality.82cb4341.jpg";